import React from 'react'
import { Container, Breadcrumbs, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import HomeIcon from '@material-ui/icons/Home'

export default function BreadCrumbOwn({ title }) {
  return (
    <>
      <div
        style={{
          background: 'linear-gradient(135deg, #0A1F44 0%, #14306b 60%, #1d3f8a 100%)',
          borderBottom: '4px solid #2962ff',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage:
              'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.06) 0%, transparent 40%), radial-gradient(circle at 80% 80%, rgba(41,98,255,0.18) 0%, transparent 45%)',
            pointerEvents: 'none',
          }}
        />
        <Container
          style={{
            position: 'relative',
            paddingTop: 60,
            paddingBottom: 60,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              width: 48,
              height: 3,
              backgroundColor: '#2962ff',
              marginBottom: 16,
              borderRadius: 2,
            }}
          />
          <Typography
            component="h1"
            style={{
              color: '#ffffff',
              fontWeight: 700,
              fontSize: 32,
              letterSpacing: 0.3,
              lineHeight: 1.2,
              margin: 0,
            }}
          >
            {title}
          </Typography>
        </Container>
      </div>

      <Container style={{ marginTop: 16, marginBottom: 8, padding: '12px 20px' }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" style={{ color: '#9aa3b2' }} />}
          aria-label="breadcrumb"
        >
          <Link
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#0A1F44',
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            <HomeIcon style={{ fontSize: 16, marginRight: 4 }} />
            Home
          </Link>
          <Typography
            style={{ color: '#5a6374', fontSize: 14, fontWeight: 500 }}
          >
            {title}
          </Typography>
        </Breadcrumbs>
      </Container>
    </>
  )
}
